import { Injectable } from '@angular/core';
import { CallApiService } from 'src/app/shared/services/call-api.service';
import * as constants from '../../shared/helpers/constants';

@Injectable({
  providedIn: 'root'
})
export class AttendanceService {

  constructor(
    private _CallApiService: CallApiService
  ) { }

  private get_calendar_enc_url: string = constants.get_calendar_enc_url;
  private get_calendar_url: string = constants.get_calendar_url;
  private get_employer_today_attendance_url: string = constants.get_employer_today_attendance_url;
  private get_monthly_attendance_enc_url: string = constants.get_monthly_attendance_enc_url;
  private get_monthly_attendance_url: string = constants.get_monthly_attendance_url;
  private save_monthly_attendance_url: string = constants.save_monthly_attendance_url;
  private get_month_dates_days_url: string = constants.get_month_dates_days_url;
  private SaveTpVoucher_url: string = constants.SaveTpVoucher_url;
  private save_excel_bulk_att_url: string = constants.save_excel_bulk_att_url;
  private getOpeningLeaveBalance_url: string = constants.getOpeningLeaveBalance_url;
  private getGenerateOpeningBalance_url: string = constants.getGenerateOpeningBalance_url;
  private getUpdateLeaveBalance_url: string = constants.getUpdateLeaveBalance_url;
  private TpCheckInOut_url: string = constants.TpCheckInOut_url;
  private manage_missed_punch_att_url: string = constants.manage_missed_punch_att_url;
  private getEmployerMonthAttendance_for_excel_url: string = constants.getEmployerMonthAttendance_for_excel_url;
  private get_att_master_list_url: string = constants.get_att_master_list_url;
  private get_att_master_list_enc_url: string = constants.get_att_master_list_enc_url;
  private get_today_attendence_reports_url: string = constants.get_today_attendence_reports_url;
  private getMaster_Dropdown_url: string = constants.getMaster_Dropdown_url;
  private attendance_reProcessEmployeeAttendance_url: string = constants.attendance_reProcessEmployeeAttendance_url;
  private getemployeelistFace_url: string = constants.getemployeelistFace_url;



  get_calendar(userData: any) {
    return this._CallApiService.post_enc(userData, this.get_calendar_url);
  }
  get_calendar_enc(userData: any) {
    return this._CallApiService.post_enc(userData, this.get_calendar_enc_url);
  }
  get_employer_today_attendance(userData: any) {
    return this._CallApiService.post_enc(userData, this.get_employer_today_attendance_url);
  }
  get_monthly_attendance_enc(userData: any) {
    return this._CallApiService.post_enc(userData, this.get_monthly_attendance_enc_url);
  }
  get_monthly_attendance(userData: any) {
    return this._CallApiService.post_enc(userData, this.get_monthly_attendance_url);
  }
  save_monthly_attendance(userData: any) {
    return this._CallApiService.post_enc(userData, this.save_monthly_attendance_url);
  }
  get_month_dates_days(userData: any) {
    return this._CallApiService.post_enc(userData, this.get_month_dates_days_url);
  }
  saveTpVoucher(userData: any) {
    return this._CallApiService.post_enc(userData, this.SaveTpVoucher_url);
  }
  save_excel_bulk_att(userData: any) {
    return this._CallApiService.post_enc(userData, this.save_excel_bulk_att_url);
  }

  getOpeningLeaveBalance(userData: any) {
    return this._CallApiService.post_enc(userData, this.getOpeningLeaveBalance_url);
  }
  getGenerateOpeningBalance(userData: any) {
    return this._CallApiService.post_enc(userData, this.getGenerateOpeningBalance_url);
  }
  getUpdateLeaveBalance(userData: any) {
    return this._CallApiService.post_enc(userData, this.getUpdateLeaveBalance_url);
  }
  TpCheckInOut(userData: any) {
    return this._CallApiService.post_enc(userData, this.TpCheckInOut_url);
  }

  manage_missed_punch_att(userData: any) {
    return this._CallApiService.post_enc(userData, this.manage_missed_punch_att_url);
  }
  getEmployerMonthAttendance_for_excel(userData: any) {
    return this._CallApiService.post_enc(userData, this.getEmployerMonthAttendance_for_excel_url);
  }
  get_att_master_list(userData: any) {
    return this._CallApiService.post_enc(userData, this.get_att_master_list_url);
  }
  get_att_master_list_enc(userData: any) {
    return this._CallApiService.post_enc(userData, this.get_att_master_list_enc_url);
  }

  get_today_attendence_reports(userData: any) {
    return this._CallApiService.post_enc(userData, this.get_today_attendence_reports_url);
  }

  getMaster(userData: any) {
    return this._CallApiService.post_enc(userData, this.getMaster_Dropdown_url);
  }

  attendanceProcessEmployeeAttendance(userData: any) {
    return this._CallApiService.post_enc(userData, this.attendance_reProcessEmployeeAttendance_url);
  }

  getShowHideSalarytab(userData: any) {
    return this._CallApiService.post_enc(userData, this.getemployeelistFace_url);
  }c
    // -------------------------------------Shubham---------------------------------->
     private get_missedpunch_by_mngr: string = constants.get_missedpunch_by_mngr;

    get_missed_punch_by_mngr(userData: any) {
    return this._CallApiService.post_enc(userData, this.get_missedpunch_by_mngr);
  }

   private get_month_dates_days_for_date_range_url: string = constants.get_month_dates_days_for_date_range_url;
  get_month_dates_days_for_date_range(userData: any) {
    return this._CallApiService.post_enc(userData, this.get_month_dates_days_for_date_range_url);
  }

  private getEmployerMonthAttendance_url: string = constants.getEmployerMonthAttendance_url;
  getEmployerMonthAttendance(userData: any) {
    return this._CallApiService.post_enc(userData, this.getEmployerMonthAttendance_url);
  }

  private getCustomMonthAttendance_url: string = constants.getCustomMonthAttendance_url;
  getCustomMonthAttendance(userData: any) {
    return this._CallApiService.post_enc(userData, this.getCustomMonthAttendance_url);
  }

  private get_month_dates_days_for_date_range_emp_url: string = constants.get_month_dates_days_for_date_range_emp_url;
  get_month_dates_days_for_date_range_emp(userData: any) {
    return this._CallApiService.post_enc(userData, this.get_month_dates_days_for_date_range_emp_url);
  }


  private getEmployerMonthAttendance_for_excel_enc_url: string = constants.getEmployerMonthAttendance_for_excel_enc_url;
  getEmployerMonthAttendance_for_excel_enc(userData: any) {
    return this._CallApiService.post_enc(userData, this.getEmployerMonthAttendance_for_excel_enc_url);
  }

private get_empshiftdata_mobile_url: string = constants.get_empshiftdata_mobile_url;
get_empshiftdata_mobile(userData: any) {
    return this._CallApiService.post_enc(userData, this.get_empshiftdata_mobile_url);
  }

}
